import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import {
  Divider,
  IconButton,
  Typography,
  CircularProgress,
  Checkbox,
  Box,
  TextField,
  List,
  ListItemText,
  Chip,
  Tooltip,
  MenuItem,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import EditIcon from "@mui/icons-material/Edit";
import NotesIcon from "@mui/icons-material/Notes";
import DeleteIcon from "@mui/icons-material/Delete";
import HelpIcon from "@mui/icons-material/Help";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AssessmentIcon from "@mui/icons-material/Assessment";

import { apiGet, API } from "@services/API";
import { useSnackbar } from "notistack";
import GaugeChart from "react-gauge-chart";
import MaterialTable from "@material-table/core";
import moment from "moment";

import WardAddEditDialog from "@components/WardAddEditDialog";
import PatientAddEditDialog from "@components/PatientAddEditDialog";
import ConfirmDialog from "@components/ConfirmDialog";
import PatientNotesDialog from "@components/PatientNotesDialog";

import { Patient } from "@pages";

function headers() {
  let headers = {};
  let token = localStorage.getItem("covid19_token");
  let mfa_token = localStorage.getItem("mfa_token");
  if (token && token.length > 0 && mfa_token && mfa_token.length > 0) {
    headers = { "x-access-token": token };
  }
  return headers;
}

export default function Wards({ ...props }) {
  let history = useHistory();

  const level = parseInt(localStorage.getItem("user_level"), 10);

  let hospitalID = localStorage.getItem("hospital_id");

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(true);
  const [loadingPatients, setLoadingPatients] = useState(false);

  const [data, setData] = useState([]);
  const [dataPatients, setDataPatients] = useState([]);

  const [isPatientVisible, setIsPatientVisible] = useState(false);
  const [visiblePatient, setVisiblePatient] = useState(0);

  const [dataSelectedWards, setDataSelectedWards] = useState([]);
  const [dataSummaryTotals, setDataSummaryTotals] = useState({
    usedBeds: 0,
    totalBeds: 0,
    wardCount: 0,
    patientCount: 0,
    patientActiveCount: 0,
    patientDischargedCount: 0,
    consultantCount: 0,
    nurseCount: 0,
    rooms: 0,
  });
  const [isWardAddEditVisible, setIsWardAddEditVisible] = useState(false);
  const [selectedWardID, setSelectedWardID] = useState(null);

  const [isPatientAddEditVisible, setIsPatientAddEditVisible] = useState(false);
  const [selectedPatientID, setSelectedPatientID] = useState(null);

  const [isPatientNotesVisible, setIsPatientNotesVisible] = useState(false);

  const [expanded, setExpanded] = useState(false);

  const [pageSize, setPageSize] = useState(50);
  const [rowsPerPage, setRowsPerPage] = useState([5, 10, 25, 50, 75, 100]);

  const [hospitalName, setHospitalName] = useState("");
  const [allWardsRoomData, setAllWardsRoomData] = useState([]);

  const [isConfirmPatientDeleteVisible, setIsConfirmPatientDeleteVisible] =
    useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    const timeOut = setTimeout(() => {
      setLoading(true);

      apiGet(`/facilities/` + hospitalID, { headers: headers() }, history)
        .then((response) => {
          setLoading(false);

          if (!isNullOrEmpty(response.data.facilities)) {
            setData(response.data.facilities);
            setHospitalName(response.data.facilities[0].hospital_name);

            hospitalID = response.data.facilities[0].hospital_id;

            const allWardIds = response.data.facilities.map(
              (item) => item.facility_id
            );
            console.log(" allWardIds :::", allWardIds);

            setDataSelectedWards(allWardIds);

            let allFacilitiesRoomsData = response.data.facilities.map(
              (facility) => {
                // Parse the rooms_data JSON string
                const roomsData = JSON.parse(facility.rooms_data);

                const formattedRoomsData = roomsData
                  ? roomsData.map((room) => ({
                      id: room.id,
                      beds: room.beds,
                      name: room.name,
                      gender: room.gender,
                    }))
                  : null;

                return {
                  facility_id: facility.facility_id,
                  facility: facility.facility,
                  room_data: formattedRoomsData,
                };
              }
            );

            setAllWardsRoomData(allFacilitiesRoomsData);
          } else {
            setData([]);
            setDataSelectedWards([]);
            setAllWardsRoomData(allFacilitiesRoomsData);
          }
        })
        .catch((error) => {
          console.error("Wards - fetchData error: ", error);
          setLoading(false);
          setData([]);
          setDataSelectedWards([]);
        });
    }, 100);

    return () => clearTimeout(timeOut);
  };

  const fetchPatients = (wardID) => {
    const timeOut = setTimeout(() => {
      setLoadingPatients(true);

      apiGet(`/patientsByID/` + wardID, { headers: headers() })
        .then((response) => {
          let combinedPatients = [];

          if (response.data.active) {
            combinedPatients = combinedPatients.concat(response.data.active);
          }

          if (response.data.discharged) {
            combinedPatients = combinedPatients.concat(
              response.data.discharged
            );
          }
          console.log(" patient Details ::: ", combinedPatients);
          setDataPatients(combinedPatients);
          setLoadingPatients(false);
        })
        .catch((error) => {
          setLoadingPatients(false);
          setDataPatients([]);
        });
    }, 100);

    return () => clearTimeout(timeOut);
  };

  const deletePatient = () => {
    const timeOut = setTimeout(() => {
      setLoadingPatients(true);
      const admin_user_id = localStorage.getItem("user_id");

      const patientBody = {
        AdminUserId: admin_user_id,
        PatientId: selectedPatientID,
      };

      API.post("/removePatient", patientBody, {
        headers: headers(),
      })
        .then((response) => {
          showSnackBar("success", "Success", "Successfully deleted patient.");
          setSelectedPatientID(null);
          fetchData();
          fetchPatients(selectedWardID);
        })
        .catch((error) => {
          showSnackBar("error", "Failure", "Failed to delete patient.");
          setLoadingPatients(false);
        });
    }, 100);

    return () => clearTimeout(timeOut);
  };

  useEffect(() => {
    const totals = calculateTotalsForWards(dataSelectedWards);
    setDataSummaryTotals(totals);
  }, [dataSelectedWards]);

  const showSnackBar = (type, title, subtitle) => {
    const options = { variant: type };

    enqueueSnackbar(
      <div style={{ display: "inline-grid" }}>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="subtitle1">{subtitle}</Typography>
      </div>,
      options
    );
  };

  const isNullOrEmpty = (value) => {
    if (value === null || value === undefined) {
      return true;
    }

    if (typeof value === "string" && value.trim().toLowerCase() === "null") {
      return true;
    }

    if (Array.isArray(value) && value.length === 0) {
      return true;
    }

    if (typeof value === "string" && value.trim() === "") {
      return true;
    }

    if (typeof value === "number" && isNaN(value)) {
      return true;
    }

    return false;
  };

  const onCloseWardAddEditDialog = (isFetchData) => {
    setIsWardAddEditVisible(false);
    if (isFetchData) {
      fetchData();
    }
  };

  const handleAddEditWard = (wardID) => {
    setSelectedWardID(wardID);
    setIsWardAddEditVisible(true);
  };

  const handleAddEditPatient = (wardID, patientID) => {
    setSelectedWardID(wardID);
    setSelectedPatientID(patientID);
    setIsPatientAddEditVisible(true);
  };

  const handleDeletePatient = (patientID) => {
    setSelectedPatientID(patientID);
    setIsConfirmPatientDeleteVisible(true);
  };

  const handleItemClick = (item) => {
    // localStorage.setItem("hospitalID", item.id);
    // history.push("/wards");
  };

  const handleChangePage = (event) => {
    //event.target.value === 'All' ? setRowsPerPage(data.length) : setRowsPerPage(event.target.value);
  };

  const handleChangeRowsPerPage = (event) => {
    setPageSize(event);
  };

  const generateOccupancyGraph = (usedBeds, totalBeds) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          width: 90,
          height: 90,
        }}
      >
        <Typography variant="subtitle2">Occupancy</Typography>
        <GaugeChart
          //id={`gauge-${element.title}`}
          nrOfLevels={3}
          arcsLength={[0.3, 0.5, 0.2]}
          colors={["#00c9a7", "#ffc473", "#ff5f6d"]}
          percent={totalBeds > 0 ? (usedBeds / totalBeds).toFixed(1) : 0.0}
          hideText={true}
        />
        <Typography variant="caption">
          {usedBeds} of {totalBeds} Beds
        </Typography>
      </div>
    );
  };

  const handleWardSelect = (event) => {
    const selectedValues = event.target.value;
    setDataSelectedWards(selectedValues);
  };

  const calculateTotalsForWards = (selectedValues) => {
    const totals = {
      usedBeds: 0,
      totalBeds: 0,
      wardCount: 0,
      patientCount: 0,
      patientActiveCount: 0,
      patientDischargedCount: 0,
      consultantCount: 0,
      nurseCount: 0,
      rooms: 0,
    };

    for (const hospital of data) {
      if (selectedValues.includes(hospital.facility_id)) {
        totals.usedBeds += hospital.used_beds;
        totals.totalBeds += hospital.total_beds;
        totals.wardCount += hospital.ward_count;
        totals.patientCount += hospital.patient_count;
        totals.patientActiveCount += hospital.active_patient_count;
        totals.patientDischargedCount += hospital.discharged_patient_count;
        totals.rooms += hospital.rooms;
        totals.consultantCount += hospital.doctor_count;
        totals.nurseCount += hospital.nurse_count;
      }
    }

    return totals;
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);

    if (isExpanded) {
      setSelectedWardID(panel);
      fetchPatients(panel);
    } else {
      setSelectedWardID(null);
    }
  };

  const handelCloseWard = () => {
    setSelectedWardID(null);
    setIsWardAddEditVisible(false);
  };

  const handelClosePatient = () => {
    setIsPatientAddEditVisible(false);
  };

  const handelSaveWard = () => {
    setSelectedWardID(null);
    setIsWardAddEditVisible(false);
    fetchData();
  };

  const handelSavePatient = () => {
    setIsPatientAddEditVisible(false);
    fetchData();
    fetchPatients(selectedWardID);
  };

  const onCloseScreen = () => {
    setIsPatientVisible(false);
  };

  const showPatientDetails = (rowData) => {
    setIsPatientVisible(true);
    setVisiblePatient(rowData.patient_id);
  };

  const showPatientNotes = (rowData) => {
    setSelectedPatientID(rowData.patient_id);
    setIsPatientNotesVisible(true);
  };

  console.log("dataSelectedWards :", dataSelectedWards);
  console.log("data :", data);

  return (
    <Box style={{ padding: 15 }}>
      <Grid container spacing={2}>
        {loading ? (
          <Grid item xs={12}>
            <CircularProgress color="primary" />
          </Grid>
        ) : (
          <>
            <Grid
              item
              xs={12}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Typography
                data-test={"ward-header"}
                variant="h5"
                style={{ paddingRight: 5 }}
              >
                {!isNullOrEmpty(hospitalName)
                  ? hospitalName + " - Wards"
                  : "Wards"}
              </Typography>
              {level != 7 && level != 8 && (
                <div style={{ display: "flex", gap: "20px" }}>
                  <Tooltip title="Add Ward">
                    <div>
                      <IconButton
                        data-test="ward-add-ward-btn"
                        aria-label="Add Ward"
                        size="large"
                        color="primary"
                        onClick={() => handleAddEditWard(null)}
                      >
                        <AddCircleIcon fontSize="inherit" />
                      </IconButton>
                      <span>Add Ward</span>
                    </div>
                  </Tooltip>
                  <Tooltip title="Add Patient">
                    <div>
                      <IconButton
                        data-test="ward-add-ward-btn"
                        aria-label="Add Patient"
                        size="large"
                        color="primary"
                        onClick={() => handleAddEditPatient(null)}
                      >
                        <AddCircleIcon fontSize="inherit" />
                      </IconButton>
                      <span>Add Patient</span>
                    </div>
                  </Tooltip>
                </div>
              )}
            </Grid>

            {!isNullOrEmpty(data) ? (
              <>
                <Grid item xs={12}>
                  <Grid
                    container
                    spacing={1}
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Grid item xs={12} md={3}>
                      <TextField
                        id="outlined-select-ward"
                        select
                        fullWidth
                        label="Wards"
                        value={dataSelectedWards}
                        onChange={handleWardSelect}
                        SelectProps={{
                          multiple: true,
                          margin: "dense",
                          padding: 0,
                          renderValue: (selected) => (
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                              {selected.map((item) => (
                                <Chip
                                  key={item}
                                  label={
                                    data.find(
                                      (ward) => ward.facility_id === item
                                    ).facility
                                  }
                                  style={{ margin: "2px" }}
                                />
                              ))}
                            </div>
                          ),
                        }}
                      >
                        {data.map((ward) => (
                          <MenuItem
                            key={ward.facility_id}
                            value={ward.facility_id}
                          >
                            <Checkbox
                              checked={
                                dataSelectedWards.indexOf(ward.facility_id) > -1
                              }
                            />
                            <ListItemText primary={ward.facility} />
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      md={1}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      {generateOccupancyGraph(
                        dataSummaryTotals.usedBeds,
                        dataSummaryTotals.totalBeds
                      )}
                    </Grid>

                    <Grid item xs={4} md={1} style={{ textAlign: "center" }}>
                      <Typography variant="subtitle2">Patients</Typography>
                      <Typography data-test={"ward-patient-count"}>
                        {dataSummaryTotals.patientCount}
                      </Typography>
                    </Grid>

                    <Grid item xs={4} md={1} style={{ textAlign: "center" }}>
                      <Typography variant="subtitle2">
                        Active Patients
                      </Typography>
                      <Typography data-test={"ward-active-patient-count"}>
                        {dataSummaryTotals.patientActiveCount}
                      </Typography>
                    </Grid>

                    <Grid item xs={4} md={1} style={{ textAlign: "center" }}>
                      <Typography variant="subtitle2">
                        Discharged Patients
                      </Typography>
                      <Typography data-test={"ward-discharged-patient-count"}>
                        {dataSummaryTotals.patientDischargedCount}
                      </Typography>
                    </Grid>

                    <Grid item xs={3} md={1} style={{ textAlign: "center" }}>
                      <Typography variant="subtitle2">Rooms</Typography>
                      <Typography data-test={"ward-rooms-count"}>
                        {dataSummaryTotals.rooms}
                      </Typography>
                    </Grid>

                    <Grid item xs={3} md={1} style={{ textAlign: "center" }}>
                      <Typography variant="subtitle2">Beds</Typography>
                      <Typography data-test={"ward-beds-count"}>
                        {dataSummaryTotals.totalBeds}
                      </Typography>
                    </Grid>

                    <Grid item xs={3} md={1} style={{ textAlign: "center" }}>
                      <Typography variant="subtitle2">Consultants</Typography>
                      <Typography>
                        {dataSummaryTotals.consultantCount}
                      </Typography>
                    </Grid>

                    <Grid item xs={3} md={1} style={{ textAlign: "center" }}>
                      <Typography variant="subtitle2">Nurses</Typography>
                      <Typography>{dataSummaryTotals.nurseCount}</Typography>
                    </Grid>

                    <Grid item xs={12} md={1} style={{ textAlign: "center" }}>
                      <Tooltip title="Help">
                        <IconButton
                          aria-label="help"
                          size="large"
                          color="primary"
                          onClick={(event) => {
                            event.stopPropagation();
                            showSnackBar(
                              "info",
                              "Info",
                              "This feature is not available."
                            );
                          }}
                        >
                          <HelpIcon fontSize="inherit" />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Typography
                    data-test={"ward-list-title"}
                    variant="subtitle2"
                    style={{ textAlign: "center" }}
                  >
                    Ward List
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Divider />
                </Grid>

                {dataSelectedWards.length > 0 ? (
                  <Grid item xs={12}>
                    <List>
                      {data
                        .filter((item) =>
                          dataSelectedWards.includes(item.facility_id)
                        )
                        .map((item, index) => (
                          <Accordion
                            data-test="ward-entry"
                            id="wards-accordion-id"
                            key={item.facility_id}
                            expanded={expanded === item.facility_id}
                            onChange={handleChange(item.facility_id)}
                            style={{
                              backgroundColor:
                                item.facility_id === 999999
                                  ? "#faede1"
                                  : expanded === item.facility_id
                                  ? "#cbe5d5"
                                  : "#ebf5ef",
                              marginBottom: 10,
                            }}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1bh-content"
                              id="panel1bh-header"
                              //style={{ flexDirection: "column" }}
                            >
                              <Grid
                                container
                                spacing={1}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  width: "100%",
                                }}
                              >
                                {item.facility_id !== 999999 ? (
                                  <Grid
                                    item
                                    xs={12}
                                    sm={4}
                                    md={1}
                                    style={{ textAlign: "center" }}
                                  >
                                    <Typography
                                      data-test="ward-name"
                                      variant="subtitle1"
                                      fontWeight={"bold"}
                                    >
                                      {item.facility}
                                    </Typography>
                                    <Typography
                                      data-test="ward-location"
                                      variant="caption"
                                    >
                                      {item.location}
                                    </Typography>
                                  </Grid>
                                ) : (
                                  <Grid
                                    item
                                    xs={12}
                                    sm={10}
                                    md={8}
                                    lg={6}
                                    style={{ textAlign: "left" }}
                                  >
                                    <Typography
                                      data-test="ward-name"
                                      variant="subtitle1"
                                      style={{
                                        fontWeight: "bold",
                                        marginBottom: "4px",
                                      }}
                                    >
                                      To Come In (TCI - Patient Scheduling)
                                    </Typography>
                                    <Typography
                                      data-test="ward-location"
                                      variant="caption"
                                    >
                                      Management / tracking used for incoming
                                      patients who are scheduled for admission.
                                    </Typography>
                                  </Grid>
                                )}

                                {item.facility_id !== 999999 && (
                                  <Grid
                                    item
                                    xs={12}
                                    sm={4}
                                    md={1}
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {generateOccupancyGraph(
                                      item.used_beds,
                                      item.total_beds
                                    )}
                                  </Grid>
                                )}

                                <Grid
                                  item
                                  xs={12}
                                  sm={4}
                                  md={2}
                                  style={{ textAlign: "center" }}
                                >
                                  <Typography variant="subtitle2">
                                    Data Controller
                                  </Typography>
                                  <Typography>
                                    {item.data_controller_firstname +
                                      " " +
                                      item.data_controller_surname}
                                  </Typography>
                                </Grid>

                                <Grid
                                  item
                                  xs={4}
                                  sm={4}
                                  md={1}
                                  style={{ textAlign: "center" }}
                                >
                                  <Typography variant="subtitle2">
                                    Patients
                                  </Typography>
                                  <Typography>{item.patient_count}</Typography>
                                </Grid>

                                {item.facility_id !== 999999 && (
                                  <Grid
                                    item
                                    xs={4}
                                    sm={4}
                                    md={1}
                                    style={{ textAlign: "center" }}
                                  >
                                    <Typography variant="subtitle2">
                                      Active Patients
                                    </Typography>
                                    <Typography>
                                      {item.active_patient_count}
                                    </Typography>
                                  </Grid>
                                )}
                                {item.facility_id !== 999999 && (
                                  <Grid
                                    item
                                    xs={4}
                                    sm={4}
                                    md={1}
                                    style={{ textAlign: "center" }}
                                  >
                                    <Typography variant="subtitle2">
                                      Discharged Patients
                                    </Typography>
                                    <Typography>
                                      {item.discharged_patient_count}
                                    </Typography>
                                  </Grid>
                                )}
                                {item.facility_id !== 999999 && (
                                  <Grid
                                    item
                                    xs={3}
                                    sm={3}
                                    md={1}
                                    style={{ textAlign: "center" }}
                                  >
                                    <Typography variant="subtitle2">
                                      Rooms
                                    </Typography>
                                    <Typography>{item.rooms}</Typography>
                                  </Grid>
                                )}
                                {item.facility_id !== 999999 && (
                                  <Grid
                                    item
                                    xs={3}
                                    sm={3}
                                    md={1}
                                    style={{ textAlign: "center" }}
                                  >
                                    <Typography variant="subtitle2">
                                      Beds
                                    </Typography>
                                    <Typography>{item.total_beds}</Typography>
                                  </Grid>
                                )}
                                {item.facility_id !== 999999 && (
                                  <Grid
                                    item
                                    xs={3}
                                    sm={3}
                                    md={1}
                                    style={{ textAlign: "center" }}
                                  >
                                    <Typography variant="subtitle2">
                                      Consultants
                                    </Typography>
                                    <Typography>{item.doctor_count}</Typography>
                                  </Grid>
                                )}
                                {item.facility_id !== 999999 && (
                                  <Grid
                                    item
                                    xs={3}
                                    sm={3}
                                    md={1}
                                    style={{ textAlign: "center" }}
                                  >
                                    <Typography variant="subtitle2">
                                      Nurses
                                    </Typography>
                                    <Typography>{item.nurse_count}</Typography>
                                  </Grid>
                                )}

                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={1}
                                  style={{ textAlign: "center" }}
                                >
                                  <Tooltip title="Add Patient">
                                    <IconButton
                                      data-test="ward-add-patient-btn"
                                      aria-label="add"
                                      size="large"
                                      color="primary"
                                      disabled={
                                        selectedWardID !== null
                                          ? item.facility_id !== selectedWardID
                                          : true
                                      }
                                      onClick={(event) => {
                                        event.stopPropagation();

                                        handleAddEditPatient(
                                          item.facility_id,
                                          null
                                        );
                                      }}
                                    >
                                      <AddCircleIcon fontSize="inherit" />
                                    </IconButton>
                                  </Tooltip>
                                  {level != 7 &&
                                    level != 8 &&
                                    item.facility_id !== 999999 && (
                                      <Tooltip title="Edit Ward">
                                        <IconButton
                                          data-test="ward-edit-btn"
                                          aria-label="edit"
                                          size="large"
                                          color="primary"
                                          onClick={(event) => {
                                            event.stopPropagation();
                                            handleAddEditWard(item.facility_id);
                                          }}
                                        >
                                          <EditIcon fontSize="inherit" />
                                        </IconButton>
                                      </Tooltip>
                                    )}

                                  {level != 7 &&
                                    level != 8 &&
                                    item.facility_id !== 999999 && (
                                      <Tooltip title="Delete Ward">
                                        <IconButton
                                          data-test="ward-delete-btn"
                                          aria-label="delete"
                                          size="large"
                                          color="red"
                                          onClick={(event) => {
                                            event.stopPropagation();
                                            showSnackBar(
                                              "info",
                                              "Info",
                                              "This feature is not available."
                                            );
                                          }}
                                        >
                                          <DeleteIcon
                                            fontSize="inherit"
                                            color="red"
                                          />
                                        </IconButton>
                                      </Tooltip>
                                    )}

                                  <Tooltip title="Help">
                                    <IconButton
                                      data-test="ward-help-btn"
                                      aria-label="help"
                                      size="large"
                                      color="primary"
                                      onClick={(event) => {
                                        event.stopPropagation();
                                        showSnackBar(
                                          "info",
                                          "Info",
                                          "This feature is not available."
                                        );
                                      }}
                                    >
                                      <HelpIcon fontSize="inherit" />
                                    </IconButton>
                                  </Tooltip>

                                  {item.facility_id !== 999999 && (
                                    <Tooltip title="Daily Report">
                                      <IconButton
                                        data-test="ward-daily-report-btn"
                                        aria-label="daily-report"
                                        size="large"
                                        color="primary"
                                        onClick={(event) => {
                                          event.stopPropagation();
                                          history.push({
                                            pathname: "/reports",
                                            search: `?type=${encodeURIComponent(
                                              "Daily"
                                            )}&hospitalID=${encodeURIComponent(
                                              hospitalID
                                            )}&wardID=${encodeURIComponent(
                                              item.facility_id
                                            )}`,
                                          });
                                        }}
                                      >
                                        <AssessmentIcon fontSize="inherit" />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </Grid>
                              </Grid>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <Divider />
                                </Grid>
                                {loadingPatients ? (
                                  <Grid item xs={12}>
                                    <CircularProgress color="primary" />
                                  </Grid>
                                ) : (
                                  <>
                                    {dataPatients.length > 0 ? (
                                      <Grid
                                        item
                                        xs={12}
                                        data-test={"ward-patient-list"}
                                      >
                                        <MaterialTable
                                          style={{}}
                                          title="Patients"
                                          columns={[
                                            {
                                              title: "MRN",
                                              field: "mrn",
                                              filtering: false,
                                            },
                                            {
                                              title: "Firstname",
                                              field: "firstname",
                                              filtering: false,
                                            },
                                            {
                                              title: "Surname",
                                              field: "surname",
                                              filtering: false,
                                            },
                                            {
                                              title: "Gender",
                                              field: "gender",
                                              filtering: false,
                                              render: (rowData) => {
                                                const gender =
                                                  rowData.gender === "m"
                                                    ? "Male"
                                                    : rowData.gender === "u"
                                                    ? "Unknown"
                                                    : "Female";
                                                return gender;
                                              },
                                            },
                                            {
                                              title: "Status",
                                              field: "status",
                                              filtering:
                                                item.facility_id !== 999999
                                                  ? true
                                                  : false,
                                              lookup: {
                                                0: "Active",
                                                1: "Discharged",
                                                2: "Scheduled",
                                              },
                                              render: (rowData) => {
                                                if (rowData.status === 0) {
                                                  return "Active";
                                                } else if (
                                                  rowData.status === 1
                                                ) {
                                                  return "Discharged";
                                                } else if (
                                                  rowData.status === 2
                                                ) {
                                                  return "Scheduled";
                                                }
                                              },
                                            },
                                            ...(item.facility_id !== 999999
                                              ? [
                                                  {
                                                    title: "Room",
                                                    field: "room_name",
                                                    filtering: false,
                                                  },
                                                ]
                                              : []),
                                            {
                                              title:
                                                item.facility_id !== 999999
                                                  ? "Admission Date"
                                                  : "Scheduled Admission Date",
                                              field: "timestamp",
                                              filtering: false,
                                              render: (rowData) => {
                                                return moment(
                                                  rowData.timestamp
                                                ).format("DD/MM/yyyy");
                                              },
                                            },

                                            {
                                              title: "EDD",
                                              field: "exptected_discharge_date",
                                              filtering: false,
                                              render: (rowData) => {
                                                return moment(
                                                  rowData.exptected_discharge_date
                                                ).format("DD/MM/yyyy");
                                              },
                                            },
                                            ...(item.facility_id !== 999999
                                              ? [
                                                  {
                                                    title: "Length Of Stay",
                                                    field: "stay_length",
                                                    filtering: false,
                                                    render: (rowData) => {
                                                      return rowData.stay_length;
                                                    },
                                                  },
                                                ]
                                              : []),

                                            {
                                              title: "GDPR Acceptance",
                                              field: "gdpr_acceptance",
                                              filtering: false,
                                              render: (rowData) => {
                                                return rowData.gdpr_acceptance ===
                                                  1
                                                  ? "Yes"
                                                  : "No";
                                              },
                                            },
                                          ]}
                                          data={dataPatients}
                                          options={{
                                            padding: "dense",
                                            addRowPosition: "first",
                                            exportAllData: true,
                                            filtering: true,
                                            pageSize: pageSize,
                                            pageSizeOptions: rowsPerPage,
                                            loadingType: "overlay",
                                            tableLayout: "auto",
                                            emptyRowsWhenPaging: false,
                                            //minBodyHeight: "75vh",
                                            //maxBodyHeight: "75vh",
                                            headerStyle: {
                                              position: "sticky",
                                              top: 0,
                                              backgroundColor: "#fff",
                                              zIndex: "1",
                                            },
                                          }}
                                          actions={[
                                            {
                                              icon: (props) => (
                                                <VisibilityIcon
                                                  {...props}
                                                  color="primary"
                                                  data-test="ward-patient-view-btn"
                                                />
                                              ),
                                              tooltip: "View Patient",
                                              onClick: (event, rowData) =>
                                                showPatientDetails(rowData),
                                            },
                                            {
                                              icon: (props) => (
                                                <EditIcon
                                                  {...props}
                                                  color="primary"
                                                  data-test="ward-patient-edit-btn"
                                                />
                                              ),
                                              tooltip: "Edit Patient",
                                              onClick: (event, rowData) =>
                                                handleAddEditPatient(
                                                  item.facility_id,
                                                  rowData.patient_id
                                                ),
                                            },
                                            {
                                              icon: (props) => (
                                                <NotesIcon
                                                  {...props}
                                                  color="primary"
                                                  data-test="ward-patient-notes-btn"
                                                />
                                              ),
                                              tooltip: "Notes",
                                              onClick: (event, rowData) =>
                                                showPatientNotes(rowData),
                                            },

                                            {
                                              icon: (props) => (
                                                <DeleteIcon
                                                  {...props}
                                                  color="red"
                                                  data-test="ward-patient-delete-btn"
                                                />
                                              ),
                                              tooltip: "Delete Patient",
                                              onClick: (event, rowData) =>
                                                handleDeletePatient(
                                                  rowData.patient_id
                                                ),
                                            },
                                            // {
                                            //   icon: 'delete',
                                            //   tooltip: 'Delete',
                                            //   onClick: (event, rowData) => {
                                            //     setSelectedRow(rowData);
                                            //     setIsDeleteCarePlanVisible(true);
                                            //   },
                                            // },
                                          ]}
                                          isLoading={loadingPatients}
                                          onPageChange={handleChangePage}
                                          onRowsPerPageChange={
                                            handleChangeRowsPerPage
                                          }
                                        />
                                      </Grid>
                                    ) : (
                                      <Grid item xs={12}>
                                        <Typography
                                          data-test={
                                            "ward-patient-list-empty-msg"
                                          }
                                          style={{ textAlign: "center" }}
                                        >
                                          No records to display
                                        </Typography>
                                      </Grid>
                                    )}
                                  </>
                                )}
                              </Grid>
                            </AccordionDetails>
                          </Accordion>
                        ))}
                    </List>
                  </Grid>
                ) : (
                  <Grid item xs={12}>
                    <Typography style={{ textAlign: "center" }}>
                      No records to display
                    </Typography>
                  </Grid>
                )}
              </>
            ) : (
              <Grid item xs={12}>
                <Typography style={{ textAlign: "center" }}>
                  No records to display
                </Typography>
              </Grid>
            )}

            {isWardAddEditVisible && (
              <WardAddEditDialog
                isVisible={isWardAddEditVisible}
                onClose={handelCloseWard}
                onSave={handelSaveWard}
                hospitalID={hospitalID}
                wardID={selectedWardID}
              />
            )}

            {isPatientAddEditVisible && (
              <PatientAddEditDialog
                isVisible={isPatientAddEditVisible}
                onClose={handelClosePatient}
                onSave={handelSavePatient}
                patientID={selectedPatientID}
                wardID={selectedWardID}
                hospitalID={hospitalID}
                // allWardsRoomData={allWardsRoomData}
                allWardsRoomData={allWardsRoomData.filter(
                  (item) => item.facility_id !== 999999
                )}
              />
            )}

            {isConfirmPatientDeleteVisible && (
              <ConfirmDialog
                title="Confirm"
                open={isConfirmPatientDeleteVisible}
                setOpen={setIsConfirmPatientDeleteVisible}
                onConfirm={deletePatient}
                onCancel={() => {
                  setIsConfirmPatientDeleteVisible(false);
                }}
              >
                Are you sure you want to permanently delete this patient ?
              </ConfirmDialog>
            )}

            {isPatientNotesVisible && (
              <PatientNotesDialog
                isVisible={isPatientNotesVisible}
                onClose={() => setIsPatientNotesVisible(false)}
                patientID={selectedPatientID}
              />
            )}
          </>
        )}
      </Grid>
      {isPatientVisible && (
        <Patient
          isVisible={isPatientVisible}
          onCloseScreen={onCloseScreen}
          patientId={visiblePatient}
        />
      )}
    </Box>
  );
}
